document.addEventListener('DOMContentLoaded', function () {
    var skipLink = document.querySelector('.skip-to-description-link');
    var targetSection = document.getElementById('TabsDescription');

    skipLink.addEventListener('click', function (event) {
        event.preventDefault();

        var scrollHeight = targetSection.offsetTop - 145;

        window.scrollTo({
            top: scrollHeight,
            behavior: 'smooth'
        });
    });
});